import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sidebarShow: true,
  asideShow: false,
  theme: 'dark',
  sidebarUnfold: false,
}

export const changeState = createSlice({
  name: 'sidebar-toggle',
  initialState,
  reducers: {
    setSidebarToggle: (state, action) => {
      state.sidebarUnfold = action.payload.sidebarUnfold
    },
  },
})

export const { setSidebarToggle } = changeState.actions
export default changeState.reducer
